import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration } from './models/configuration';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  public configData: Configuration | undefined;
  private readonly configPath: string = '/config.json';
  constructor(private http: HttpClient) {}

  async loadConfiguration(): Promise<any> {
    try {
      const response: any = await this.http
        .get(`${this.configPath}`)
        .toPromise();
      this.configData = response;
      return this.configData;
    } catch (err) {
      //fallback dummy data - staging env
      this.configData = {
        APP_API_URL: '/api',
      };
      return this.configData;
    }
  }

  get config(): Configuration | undefined {
    return this.configData;
  }
}
